"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.remove = exports.get = void 0;
var local_storage_1 = require("./local-storage");
var Cookies = require("./cookies");
var WindowStorage = require("./window-storage");
var storage_types_1 = require("../constants/storage-types");
function get(key, method) {
    if (method === storage_types_1.default.LOCAL_STORAGE && local_storage_1.isLSAvailable()) {
        return local_storage_1.retrieve(key);
    }
    else if (method === storage_types_1.default.COOKIES) {
        return Cookies.get(key, true);
    }
    else if (method === storage_types_1.default.WINDOW) {
        return WindowStorage.retrieve(key);
    }
    else {
        if (local_storage_1.isLSAvailable()) {
            return local_storage_1.retrieve(key);
        }
    }
}
exports.get = get;
function remove(key, method) {
    if ((method === storage_types_1.default.LOCAL_STORAGE) && local_storage_1.isLSAvailable()) {
        local_storage_1.clear(key);
    }
    else if (method === storage_types_1.default.COOKIES) {
        Cookies.remove(key);
    }
    else if (method === storage_types_1.default.WINDOW) {
        WindowStorage.clear(key);
    }
    else {
        if (local_storage_1.isLSAvailable()) {
            local_storage_1.clear(key);
        }
    }
}
exports.remove = remove;
function set(key, value, method) {
    if ((method === storage_types_1.default.LOCAL_STORAGE) && local_storage_1.isLSAvailable()) {
        local_storage_1.store(key, value);
    }
    else if (method === storage_types_1.default.COOKIES) {
        Cookies.set(key, value);
    }
    else if (method === storage_types_1.default.WINDOW) {
        WindowStorage.store(key, value);
    }
    else {
        if (local_storage_1.isLSAvailable()) {
            local_storage_1.store(key, value);
        }
    }
}
exports.set = set;
